export const DEFAULT_TYPE_ID = '4';
export const DEFAULT_PKG = '1';
export const DEFAULT_IS_COMPREHENSIVE_NUMBER = '-1';
export const DEFAULT_NUMBER = '0';

export const DEFAULT_STORE_URL = `/store?type=${DEFAULT_TYPE_ID}&package=${DEFAULT_PKG}`;
